import gameKit from './js/GameKit';
import Cheats from './js/Cheats';
import GamePlayer, { GetGamePlayerInstance } from './js/GamePlayer';

Cheats.start();

const gameKitRoot = document.getElementById('gamekit');

if (!gameKitRoot) {
    const gamePlayerRoot = document.getElementById('gameplayer');

    if (!gamePlayerRoot) {
        throw new Error('GameKit and GamePlayer failed to initialize. Div with ID "gamekit" or "gameplayer" could not be found.');
    }

    const csrfToken = gamePlayerRoot.dataset.csrftoken;
    const gameID = gamePlayerRoot.dataset.gameid;
    const settingsPath = gamePlayerRoot.dataset.settings;

    const gamePlayer = new GamePlayer();
    gamePlayer.init(settingsPath, gameID, csrfToken);
} else {

    const mmSessionId = gameKitRoot.dataset.mmsessionid;
    const csrfToken = gameKitRoot.dataset.csrftoken;
    const gameID = gameKitRoot.dataset.gameid;
    const settingsPath = gameKitRoot.dataset.settings;
    const isCopy = gameKitRoot.dataset.copy === 'true' || gameKitRoot.dataset.copy === 1 || gameKitRoot.dataset.copy === '1';
    gameKit.init(settingsPath, gameID, isCopy, csrfToken, mmSessionId);
}
